import { render, staticRenderFns } from "./AddActionTypeModal.vue?vue&type=template&id=77bad6bb&scoped=true&class=fill-height&"
import script from "./AddActionTypeModal.vue?vue&type=script&lang=ts&"
export * from "./AddActionTypeModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddActionTypeModal.vue?vue&type=style&index=0&id=77bad6bb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bad6bb",
  null
  
)

export default component.exports